module.exports = __webpack_public_path__ + "static/media/mgallerytwo.59161cb6.jpg";